// extracted by mini-css-extract-plugin
export default {"wrap":"SearchBar_wrap__7dcoY","input":"SearchBar_input__pGfMr","icon":"SearchBar_icon__vhzdh","clear":"SearchBar_clear__K+6mA"};